var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibilityOnSiteParking = function SvgAccessibilityOnSiteParking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M6.368 25.522v2.353A1.027 1.027 0 0 1 5.344 28.9H4.038a1.027 1.027 0 0 1-1.024-1.025v-2.353m.078-9.042C1.74 16.33.726 15.473.827 14.567s1.28-1.523 2.63-1.368q.476.051.92.227m.001 5.781v1.546c0 .283.229.512.512.512h3.67c.282 0 .512-.23.512-.512v-.646a.51.51 0 0 0-.356-.488l-3.67-.896a.51.51 0 0 0-.668.484m17.655 6.315v2.353c.001.565.46 1.023 1.025 1.025h1.312a1.027 1.027 0 0 0 1.024-1.025v-2.353"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m24.535 15.716 1.533 2.651c.375.65.573 1.387.573 2.137v4.118a.77.77 0 0 1-.768.768H2.526a.77.77 0 0 1-.768-.768v-4.118c0-.75.198-1.487.573-2.137l1.535-2.65m22.776 7.463H1.758m22.778-7.464H3.864m13.402 5.497h-6.132m6.132-1.512h-6.132m8.657-10.955H7.474a1.28 1.28 0 0 0-1.197.819l-2.41 6.151m20.669 0-2.012-5.111m2.784 5.875c1.353-.151 2.365-1.007 2.265-1.913s-1.279-1.523-2.63-1.368q-.476.051-.92.227"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M24.023 19.207v1.546c0 .283-.23.512-.513.512h-3.669a.51.51 0 0 1-.512-.512v-.646c0-.223.144-.42.355-.488l3.67-.896a.51.51 0 0 1 .669.484"
  }), /*#__PURE__*/React.createElement("rect", {
    vectorEffect: "non-scaling-stroke",
    width: 9.389,
    height: 9.389,
    x: 19.791,
    y: 1.1,
    rx: 4.694
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M23.526 3.098h.896a1.65 1.65 0 0 1 1.42.729c.301.463.316 1.04.038 1.516a1.64 1.64 0 0 1-1.384.789h-.97m-.05-2.717-.073 4.536"
  }))));
};
export default SvgAccessibilityOnSiteParking;